import { calculateRemainingValue } from 'app/helpers/Refound';

export type CheckoutSummary = {
  refundAmount: number;
  newChargeAmount: number;
};

export type CalculateCheckoutSummaryParams = {
  currentPlanAmount: number;
  currentPlanStartDate: string;
  currentPlanExpirationDate: string;
  newPlanAmount: number;
};

export const calculateCheckoutSummary = ({
  currentPlanAmount,
  currentPlanStartDate,
  currentPlanExpirationDate,
  newPlanAmount,
}: CalculateCheckoutSummaryParams): CheckoutSummary => {
  const { amount: refundAmount } = calculateRemainingValue(
    currentPlanExpirationDate,
    currentPlanStartDate,
    currentPlanAmount,
  );

  return {
    refundAmount,
    newChargeAmount: newPlanAmount,
  };
};
